import React from 'react'

import { Link } from "@reach/router"

import About from './../About/About'
import Navigation from './../Navigation/Navigation'


import './Model.scss';

import gsap from 'gsap'
// import { TimelineMax } from "gsap/all"; 
import isTouch from 'is-touch'

// scene elements
import L00_sky from './assets/00-sky.png'
import L00_ground from './assets/00-ground.png'
import L00_landscape from './assets/01-landscape.png'
import L00_sea from './assets/01-sea.png'

import L01_raft from './assets/01-zattera.png'
import L01_rock_sx from './assets/01-rock-sx.png'
import L01_rock_dx from './assets/01-rock-dx.png'
import L01_cloud from './assets/01-cloud.png'

import L02_hole_hi_sx from './assets/02-hole-hi-sx.png'
import L02_model from './assets/02-model.gif'
import L02_smoke from './assets/02-smoke-adpt2.gif'

import M_01 from './assets/model1.png'
import M_02 from './assets/model2.png'
import M_03 from './assets/model3.png'
import M_04 from './assets/model4.png'
import M_05 from './assets/model5.png'
import M_06 from './assets/model6.png'
import M_07 from './assets/model7.png'
import M_08 from './assets/model8.png'
import M_09 from './assets/model9.png'
import M_10 from './assets/model10.png'
import M_11 from './assets/model11.png'
import M_12 from './assets/model12.png'

import L02_number_13 from './assets/02-numero-13.png'

import L03_hole_cx from './assets/03-hole-cx.png'
import L03_hole_hi_dx from './assets/03-hole-hi-dx.png'
import L03_rock_dx from './assets/03-rock-dx.png'
import L03_rock_sx from './assets/03-rock-sx.png'

// contributions
import contrib_01 from './../contributions/01_abnormal.gif'
import contrib_02 from './../contributions/02_lootsma.gif'
import contrib_03 from './../contributions/03_foster.gif'
import contrib_04 from './../contributions/04_fala.gif'
import contrib_05 from './../contributions/05_wai.gif'
import contrib_06 from './../contributions/06_microcities.gif'
import contrib_07 from './../contributions/07_fosbury.gif'
import contrib_08 from './../contributions/08_bose_hellberg_lesmes.gif'
import contrib_09 from './../contributions/09_ghidoni.gif'
import contrib_10 from './../contributions/10_antonas.gif'
import contrib_11 from './../contributions/11_maio.gif'
import contrib_12 from './../contributions/12_traumnovelle.gif'

function Model ({aboutVisibility, setAboutVisibility, isOpen, data, controlAudio, setControlAudio, ...rest}) {
    const scene = React.useRef( null )
    const level_1 = React.useRef( null )
    const level_2 = React.useRef( null )
    const level_2_1 = React.useRef( null )
    const level_3 = React.useRef( null )
    const level_4 = React.useRef( null )
    const level_5 = React.useRef( null )
    const cloud = React.useRef( null )
    const raft = React.useRef( null )

    React.useEffect( () => {
        !isOpen &&
            !controlAudio &&
                setControlAudio( true )
    }, [] )

    const [ windowWidth, setWindowWidth ] = React.useState( window.innerWidth )

    const [ alteration, setAlteration ] = React.useState( false )

    const maxDetectWidth = 400
    const maxDeltaMove = 3

    const onMouseMove = event => {
        let mouseFromMid = event.pageX - windowWidth / 2
        let xPos = mouseFromMid / maxDetectWidth * ( 0 - maxDeltaMove )

        gsap.to( level_1.current, { duration: 1.3, x: xPos * 9 })
        gsap.to( level_2.current, { duration: 1.3, x: xPos * 4 })
        gsap.to( level_2_1.current, { duration: 1.3, x: xPos * 4 })
        gsap.to( level_3.current, { duration: 1.3, x: xPos * 3 })
        gsap.to( level_4.current, { duration: 1.3, x: xPos * 4 })
        gsap.to( level_5.current, { duration: 1.3, x: xPos * 1 })
    }

    React.useEffect( () => {
        if (!isTouch) 
            window.addEventListener( 'mousemove', onMouseMove )

        window.addEventListener( 'resize', setWindowWidth( window.innerWidth ) )

        return () => {
            window.removeEventListener( 'mousemove', onMouseMove )
            window.removeEventListener( 'resize', setWindowWidth )
        }
    }, [ onMouseMove ] )

    React.useEffect( () => {

        gsap.set( cloud.current.parentNode, { x: cloud.current.clientWidth } )
        gsap.to( cloud.current.parentNode, { repeat: -1, yoyo: false, ease: `linear`, duration: 240, x: gsap.getProperty( cloud.current, "x") - ( window.innerWidth + cloud.current.clientWidth  ) } ) 
        gsap.to( cloud.current, { repeat: -1, yoyo: true, yoyoEase: `linear`,  duration: 8, y: gsap.getProperty( cloud.current, "y") - 10 } )

        gsap.set( raft.current, { y: gsap.getProperty( raft.current, "y") } )
        gsap.to( raft.current, { repeat: -1, yoyo: true, yoyoEase: `ease-out`, ease: `linear`, duration: 2, y: gsap.getProperty( raft.current, "y") - 10 } )

    }, [  ] )

    return(
        <div className={ [`model`, `${ isOpen ? `model--posterize` : `model--normal` }`].join( ` ` ) } >
            
            <svg ref={ scene } className={ [`model-stage`, `model-stage--${ alteration !== false ? `is-${ alteration }` : `not-altered` }`].join( ` ` ) } xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 9289.17 2000.21">

                    <filter id="posterize" filterRes="512">
                        <feComponentTransfer>
                            <feFuncR type="discrete" tableValues="0 1 1 1" />
                            <feFuncG type="discrete" tableValues="0 1 1 1" />
                            <feFuncB type="discrete" tableValues="0 0 0 0" />
                        </feComponentTransfer>
                    </filter> 


                <g id="ground" ref={ level_4 }>
                    <image onError={(e) => e.target.style.display='none' } id="ground-sx" width="6000" height="1034"  transform="translate(0 1199.79) scale(0.77)" xlinkHref={L00_ground}/>
                    <image onError={(e) => e.target.style.display='none' } id="ground-dx" width="6000" height="1034"  transform="translate(4618.59 1199.79) scale(0.77)" xlinkHref={L00_ground}/>
                </g>
                <g id="sky" ref={ level_5 }>
                    <image onError={(e) => e.target.style.display='none' } id="sky-sx" width="6000" height="1034" transform="translate(0) scale(0.77)" xlinkHref={L00_sky}/>
                    <image onError={(e) => e.target.style.display='none' } id="sky-dx" width="6000" height="1034" transform="translate(4618.59) scale(0.77)" xlinkHref={L00_sky}/>
                </g>
                <g id="background" ref={ level_3 }>
                    <g id="sea">
                    <image onError={(e) => e.target.style.display='none' } id="sea-dx" width="4800" height="296" transform="translate(4644.59 729.51) scale(0.97 0.97)" xlinkHref={L00_sea}/>
                    <image onError={(e) => e.target.style.display='none' } id="sea-sx" width="4800" height="296" transform="matrix(-0.97, 0, 0, 0.97, 4644.59, 729.51)" xlinkHref={L00_sea}/>
                    </g>
                    <g id="land">
                    <image onError={(e) => e.target.style.display='none' } id="land-sx" width="4800" height="276" transform="translate(0 1015.94) scale(0.97)" xlinkHref={L00_landscape}/>
                    <image onError={(e) => e.target.style.display='none' } id="land-dx" width="4800" height="276" transform="matrix(-0.97, 0, 0, 0.97, 9289.17, 1015.94)" xlinkHref={L00_landscape}/>
                    </g>
                    <image ref={ raft } onError={(e) => e.target.style.display='none' } id="raft" width="129" height="163" transform="translate(5800.13 779.91) scale(0.97 0.97)" xlinkHref={L01_raft}/>
                    <image onError={(e) => e.target.style.display='none' } id="rock-sx" width="1019" height="944" transform="translate(1941.54 732.86) scale(0.91 0.91)" xlinkHref={L01_rock_sx}/>
                    <image onError={(e) => e.target.style.display='none' } id="rock-dx" width="850" height="604" transform="translate(4997.95 1043.8)" xlinkHref={L01_rock_dx}/>
                </g>
                <g id="midground" ref={ level_2 }>
                    <image onError={(e) => e.target.style.display='none' } id="hole-sx" width="1150" height="225" transform="translate(1734.15 1727.48) scale(0.68 0.68)" xlinkHref={L02_hole_hi_sx}/>
                    <image onError={(e) => e.target.style.display='none' } id="model" width="1602" height="1638" transform="translate(3892.15 272.38) scale(0.9 0.9)" xlinkHref={L02_model}/>

                    <g id="windows">
                        <foreignObject id={'c1'} className={`contribution`} x="4133.7" y="479.51" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_01 } /></foreignObject>
                        <foreignObject id={'c2'} className={`contribution`} x="4420.11" y="479.48" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_02 } /></foreignObject>
                        <foreignObject id={'c3'} className={`contribution`} x="4703.18" y="479.48" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_03 } /></foreignObject>
                        <foreignObject id={'c4'} className={`contribution`} x="4980.76" y="479.51" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_04 } /></foreignObject>

                        <foreignObject id={'c5'} className={`contribution`} x="4132.5" y="886.05" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_05 } /></foreignObject>
                        <foreignObject id={'c6'} className={`contribution`} x="4420.1" y="887.34" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_06 } /></foreignObject>
                        <foreignObject id={'c7'} className={`contribution`} x="4703.18" y="887.34" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_07 } /></foreignObject>
                        <foreignObject id={'c8'} className={`contribution`} x="4980.75" y="887.29" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_08 } /></foreignObject>

                        <foreignObject id={'c9'} className={`contribution`} x="4133.7" y="1300.99" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_09 } /></foreignObject>
                        <foreignObject id={'c10'} className={`contribution`} x="4420.09" y="1297.11" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_10 } /></foreignObject>
                        <foreignObject id={'c11'} className={`contribution`} x="4703.16" y="1297.15" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_11 } /></foreignObject>
                        <foreignObject id={'c12'} className={`contribution`} x="4980.74" y="1297.1" width="164.62" height="245.22" style={{fill: 'none'}}><img alt={`contribution`} src={ contrib_12 } /></foreignObject>
                        <rect id="n13" x="5201.56" y="391.26" width="54.71" height="54.71" style={{fill: 'none'}}/>
                    </g>
                    <image onError={(e) => e.target.style.display='none' } id="hole-dx" width="1856" height="357" transform="translate(6361.32 1565.85) scale(0.7 0.7)" xlinkHref={L03_hole_hi_dx}/>
                    <image onError={(e) => e.target.style.display='none' } id="hole-cx" width="864" height="147" transform="translate(4452.81 1866.59) scale(0.91)" xlinkHref={L03_hole_cx}/>
                    <image onError={(e) => e.target.style.display='none' } id="smoke" width="737" height="433" transform="translate(4469.95) scale(0.68)" xlinkHref={L02_smoke}/>
                </g>
                <g id="foreground" ref={ level_1 }>
                    <image onError={(e) => e.target.style.display='none' } id="rock-sx-2" data-name="rock-sx" width="1287" height="685" transform="translate(2719.7 1375.97) scale(0.91)" xlinkHref={L03_rock_sx}/>
                    <image onError={(e) => e.target.style.display='none' } id="rock-dx-2" data-name="rock-dx" width="1479" height="405" transform="translate(5253.77 1636.45) scale(0.9)" xlinkHref={L03_rock_dx}/>
                </g>
                </svg>

                {
                    data &&
                     data.projects && (
                    <svg className={ `model-links-overlay` } xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 9289.17 2000.21">
                        <g id="windows" ref={ level_2_1 }>
                        <foreignObject id={'w1'} className={`window`} x="4136" y="479.51" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room01` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n01" width="23" height="43" transform="translate(4229.02 765.03) scale(0.91 0.91)" xlinkHref={M_01}/>
                        <foreignObject id={'w2'} className={`window`} x="4422.11" y="479.48" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room02` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n02" width="38" height="45" transform="translate(4487.25 762.65) scale(0.91 0.91)" xlinkHref={M_02}/>
                        <foreignObject id={'w3'} className={`window`} x="4704.18" y="479.48" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room03` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n03" width="27" height="45" transform="translate(4769.3 756.3) scale(0.91 0.91)" xlinkHref={M_03}/>
                        <foreignObject id={'w4'} className={`window`} x="4983.76" y="479.51" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room04` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n04" width="48" height="64" transform="translate(4999.98 753.58) scale(0.91 0.91)" xlinkHref={M_04}/>
    
                        <foreignObject id={'w5'} className={`window`} x="4130.62" y="885.35" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room05` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n05" width="36" height="51" transform="translate(4219.15 1174.58) scale(0.91 0.91)" xlinkHref={M_05}/>
                        <foreignObject id={'w6'} className={`window`} x="4422.1" y="885.34" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room06` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n06" width="44" height="41" transform="translate(4479 1166.85) scale(0.91 0.91)" xlinkHref={M_06}/>
                        <foreignObject id={'w7'} className={`window`} x="4704.18" y="885.34" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room07` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n07" width="38" height="41" transform="translate(4738.67 1174.09) scale(0.91 0.91)" xlinkHref={M_07}/>
                        <foreignObject id={'w8'} className={`window`} x="4983.75" y="885.29" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room08` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n08" width="27" height="60" transform="translate(5018.93 1179.33) scale(0.91 0.91)" xlinkHref={M_08}/>
    
                        <foreignObject id={'w9'} className={`window`} x="4130.7" y="1295.99" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room09` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n09" width="32" height="37" transform="translate(4210.5 1598.3) scale(0.91 0.91)" xlinkHref={M_09}/>
                        <foreignObject id={'w10'} className={`window`} x="4422.09" y="1295.91" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room10` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n10" width="83" height="57" transform="translate(4442.02 1580) scale(0.91 0.91)" xlinkHref={M_10}/>
                        <foreignObject id={'w11'} className={`window`} x="4704.16" y="1295.95" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room11` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n11" width="52" height="66" transform="translate(4732.15 1581.1) scale(0.91 0.91)" xlinkHref={M_11}/>
                        <foreignObject id={'w12'} className={`window`} x="4983.74" y="1295.9" width="164.62" height="245.22" style={{fill: 'none'}}><Link to={ `/room12` } /></foreignObject>
                        <image onError={(e) => e.target.style.display='none' } className={`number`} id="n12" width="75" height="46" transform="translate(4988.17 1590.06) scale(0.91 0.91)" xlinkHref={M_12}/>
                        {/* <image onError={(e) => e.target.style.display='none' } className={`number13`} id="number-13" width="94" height="79" transform="translate(5191.79 388.48) scale(0.74)" xlinkHref={L02_number_13}/> */}
                        <foreignObject id={'w13'} className={`window`} x="5201.56" y="391.26" width="54.71" height="54.71" style={{fill: 'none'}}>
                            <a target="_blank" href={'https://unfoldingpavilion.com/'}>
                                <img src={L02_number_13} alt={`number 13`} />
                            </a>
                        </foreignObject>


                        </g>
                    </svg>
                    )
                }
               

                <div className={`animate-cloud`} style={ { position: 'fixed',  top: 0, right: 0, width: `60vh`, height: `12vh`, zIndex: 5, display: 'block', opacity: '.5' } }>
                    <img ref={ cloud } alt={`landscape element`} src={L01_cloud} onError={(e) => e.target.style.display='none' } style={ { display: 'block', height: '100%', width: '100%' } } />
                </div>
                <About isClosed={ !aboutVisibility } data={data}  ></About>
                <Navigation isActive={ aboutVisibility } visible={ !isOpen } onClick={() => setAboutVisibility( !aboutVisibility ) } />
        </div>
    )
}

export default Model